import { SnowplowService } from 'wanderu-service-analytics';

function addTravelerDropdownClicked({ itineraryId, travelers, wheelchairs }) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'expand',
        category: 'react_tripsummary',
        label: 'add_traveler',
        property: {
            itinerary_id: itineraryId,
            travelers,
            wheelchairs,
        },
    });
}

export default {
    addTravelerDropdownClicked,
};
